import { socket } from "../index";

const emitGetRooms = () => {
  socket?.emit('GET_ROOMS', {});
}

export default emitGetRooms;